const PHASE_STATUS = {
  NOT_ACTIVE: 0,
  BREWING: 1,
  FERMENTATION: 2,
  SERVING: 3,
  CLEANING: 4
};

export default PHASE_STATUS;
